import { boxClasses, SxProps, typographyClasses } from '@mui/material'
import { dropdownButtonClasses } from '../Dropdown'

interface FilterDropdownPopoverStyles {
  dropdown: SxProps
  dropdownWrapper: SxProps
  dropdownLabel: SxProps
  dropdownIconWrapper: SxProps
  dropdownContentWrapper: SxProps
  dropdownPopper: SxProps
}

export const filterDropdownPopoverStyles: FilterDropdownPopoverStyles = {
  dropdown: {
    gap: 0,
    px: 0.5,
    py: 0.1,
    borderRadius: 12,
    [`&:focus, &.${dropdownButtonClasses.active}`]: {
      color: 'text.hyperLink',
      backgroundColor: 'brand.utility50',
      borderColor: 'utils.blue200',
      outline: 'none',

      [`& .${boxClasses.root} .${typographyClasses.root}`]: {
        color: 'text.hyperLink',
      },

      [`& .${boxClasses.root}`]: {
        color: 'utils.blue300',
      },
    },
    [`&:hover:not(.${dropdownButtonClasses.active}, &:focus)`]: {
      backgroundColor: 'utils.gray200',
      [`.${typographyClasses.root}`]: {
        color: 'utils.gray800',
      },
    },
  },
  dropdownWrapper: { display: 'flex' },
  dropdownLabel: {
    padding: '2px 6px 2px 8px',
    color: 'utils.gray700',
    typography: 'textXsMedium',
  },
  dropdownIconWrapper: { width: 12, mr: 0.375, p: 0, color: 'utils.gray700' },
  dropdownContentWrapper: {
    overflowY: 'unset',
    overflowX: 'unset',
    maxHeight: 'unset',
  },
  dropdownPopper: {
    display: 'flex',
    width: 342,
    height: 'auto',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 1.5,
  },
}
